module.exports = __webpack_public_path__ + "img/16581244_L.3322240e.png";